import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { RdCode } from '@/types/product'
import { axiosClient } from '@/utils/axios-client'

export const useRdCodeStore = defineStore('rdCode', () => {
  const rdCodes = ref<RdCode[]>([])

  async function fetchRdCodes() {
    if (rdCodes.value.length > 0) {
      return
    }
    const response = await axiosClient.request<RdCode[]>({ url: '/common/api/rd-code' })

    rdCodes.value = response.data
  }

  return {
    rdCodes,
    fetchRdCodes,
  }
})
